import { CommonModule } from '@angular/common';
import { Component, input, ChangeDetectionStrategy } from '@angular/core';
import { TranslatePipe } from '@ngx-translate/core';
import { challenge as ChallengeGen } from '@valvur/shared-grpc';
import { LessonItemComponent } from '../lesson-item/lesson-item.component';

/**
 * Component responsible for displaying the lessons list
 * Follows Single Responsibility Principle - only handles lessons list container
 */
@Component({
  selector: 'app-lessons-list',
  standalone: true,
  imports: [CommonModule, TranslatePipe, LessonItemComponent],
  templateUrl: './lessons-list.component.html',
  styleUrl: './lessons-list.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class LessonsListComponent {
  tasks = input<ChallengeGen.Task[]>([]);
  course = input<ChallengeGen.Course | undefined>(undefined);
  layoutVariant = input<'school' | 'admin'>('school');
}
